import { EndpointStatus, Announcement } from './types';

// All requests go through the Next.js proxy route to avoid CORS issues
const BASE = '/api/node-status';

export async function fetchEndpointStatuses(): Promise<EndpointStatus[]> {
  const res = await fetch(`${BASE}/endpoints/statuses?page=1&pageSize=100`);
  if (!res.ok) throw new Error('Failed to fetch endpoint statuses');
  return res.json();
}

export async function fetchEndpointDetail(key: string, page = 1): Promise<EndpointStatus> {
  const res = await fetch(`${BASE}/endpoints/${key}/statuses?page=${page}&pageSize=50`);
  if (!res.ok) throw new Error('Failed to fetch endpoint details');
  return res.json();
}

export async function fetchUptime(key: string, duration: string): Promise<number> {
  const res = await fetch(`${BASE}/endpoints/${key}/uptimes/${duration}`);
  if (!res.ok) return 0;
  return parseFloat(await res.text());
}

export async function fetchResponseTime(key: string, duration: string): Promise<number> {
  const res = await fetch(`${BASE}/endpoints/${key}/response-times/${duration}`);
  if (!res.ok) return 0;
  return parseInt(await res.text(), 10);
}

export async function fetchConfig(): Promise<{ announcements: Announcement[] }> {
  const res = await fetch(`${BASE}/config`);
  if (!res.ok) throw new Error('Failed to fetch config');
  return res.json();
}
